import { render, staticRenderFns } from "./BPConfirm.vue?vue&type=template&id=113d246d&scoped=true&"
import script from "./BPConfirm.vue?vue&type=script&lang=js&"
export * from "./BPConfirm.vue?vue&type=script&lang=js&"
import style0 from "./BPConfirm.vue?vue&type=style&index=0&id=113d246d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113d246d",
  null
  
)

component.options.__file = "BPConfirm.vue"
export default component.exports